let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("35VQy"), load("kuPgl")]).then(() => parcelRequire('5byen'));